import React from 'react';
import { Skeleton } from '@mui/material';

const SelfAssessmentDetailPageLoader = () => {
  return (
    <div className="assessment-details-wrapper flex-container">
      <div className="assessment-details">
        <Skeleton variant="text" width="80%" height={20} sx={{ mt: 5 }} />
        <Skeleton variant="text" width="70%" height={20} sx={{ mt: 1 }} />

        <Skeleton variant="text" width="50%" height={40} sx={{ mt: 4 }} />

        <Skeleton variant="text" width="50%" height={18} sx={{ mt: 2 }} />
        <Skeleton variant="text" width="55%" height={18} sx={{ mt: 1 }} />
        <Skeleton variant="text" width="60%" height={18} sx={{ mt: 1 }} />
        <Skeleton variant="text" width="55%" height={18} sx={{ mt: 1 }} />

        <Skeleton variant="rectangular" width={150} height={40} sx={{ borderRadius: 1, mt: 5 }} />

        <Skeleton variant="text" width="60%" height={18} sx={{ mt: 4 }} />
      </div>
      <div className="assessment-image">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </div>
      <style jsx>
        {`
          .assessment-details-wrapper {
            width: 100%;
          }
          .assessment-details {
            width: 50%;
          }
          .assessment-image {
            width: 50%;
            max-height: 600px;
          }
          @media only screen and (max-width: 768px) {
            .assessment-details-wrapper {
              flex-direction: column;
            }
            .assessment-details {
              width: 100%;
            }
            .assessment-image {
              order: -1;
              width: 100%;
              height: 300px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SelfAssessmentDetailPageLoader;
